import { render, staticRenderFns } from "./LamsBaseLegalCounselorHireType.vue?vue&type=template&id=6ae258c2&scoped=true&"
import script from "./LamsBaseLegalCounselorHireType.vue?vue&type=script&lang=js&"
export * from "./LamsBaseLegalCounselorHireType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae258c2",
  null
  
)

export default component.exports